<template>
    <vuescroll ref="vs">
        <div class="max-w-content">
            <article class="check-list-article">
                <div class="article-header">
                    <post-date :post="post"></post-date>
                    <h1>{{post.title}}</h1>
                    <favorite-switcher :active="favorite" :loading="loadingFavorite" @click="setFavorite"></favorite-switcher>
                    <span class="js-hide-leaving-component" title="Закрыть" @click="$emit('close')">
                        <icon-base width="16" height="16" viewBox="0 0 16 16"><icon-arrow-close/></icon-base>
                    </span>
                    <p class="checked-quantity">Выполнено: {{selectedCount}}/{{post.items.length}}</p>
                </div>
                <p v-html="post.description"></p>
                <p class="remove-selection" @click="deselectAllClick"><a href @click.prevent class="js-remove-selection">Снять выделение со всех элементов списка</a></p>
                <div class="checkbox-group">
                    <div  v-for="(item, index) in post.items" :key="index">
                        <check-list-item :item="item" @itemClick="handleItemClick"></check-list-item>
                        <div class="checkbox-item" v-if="!!getContentPart(index)" v-html="getContentPart(index)"></div>
                    </div>
                </div>
            </article>
        </div>

    </vuescroll>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import vuescroll from 'vuescroll';
    import PostDate from "../KnowledgeBase/PostDate";
    import IconBase from "../common/IconBase";
    import CheckListItem from "./CheckListItem";
    import {NOTIFICATION_SUCCESS} from "../../constants/common";
    import FavoriteSwitcher from "../common/FavoriteSwitcher";
    import IconArrowClose from "../common/icons/IconArrowClose";

    export default {
        name: 'active-list',
        components: {
            IconArrowClose,
            FavoriteSwitcher,
            CheckListItem,
            IconBase,
            PostDate,
            vuescroll
        },
        props: {
            post: Object,
        },
        data () {
            return {
                opened: false,
                favorite: false,
                loadingFavorite: false,
            }
        },
        computed: {
            ...mapGetters('checkLists',[
                'selectedCount'
            ])
        },
        methods: {
            ...mapActions('checkLists',[
                'getList',
                'deselectAll',
                'setFavoriteList'
            ]),
            handleListClick() {
                this.getList();
            },
            deselectAllClick() {
                this.deselectAll()
            },
            getContentPart(index) {
                let content = this.post.content.find(x => x.position === index);
                return content ? content.text : null
            },
            setFavorite() {
                if (!this.loadingFavorite) {
                    this.loadingFavorite = true;
                    this.setFavoriteList(!this.favorite).then(() => {
                        this.loadingFavorite = false;
                        this.favorite = !this.favorite
                    })
                }
            },
            handleItemClick() {
                if (this.post.items.length === this.selectedCount) {
                    this.$store.dispatch('pushNotification', {type: NOTIFICATION_SUCCESS, text: "Все чек листы выполнены!", time: 6000})
                }
            }
        },
    }
</script>

<style scoped>

</style>
